import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import VideoPlayer from 'src/components/common/VideoPlayer';

interface VideoExampleProps extends PageProps<{}> {
}

class VideoExample extends React.Component<VideoExampleProps> {
    constructor(props: VideoExampleProps) {
        super(props);
        bindAllOfThis(this, VideoExample.prototype);
    }

    render() {
        let subtitles = [
            // { src: require("src/assets/online-assets/video/jellies.vtt"), kind: "subtitles", srcLang: "en-US", label: "English" },
            // { src: require("src/assets/online-assets/video/jellies.vtt"), kind: "subtitles", srcLang: "en-AU", label: "Aus English" }
        ];
        return (<div>Hey you just made the VideoExample component, woot!
            {/* <VideoPlayer src={require("src/assets/online-assets/video/jellies.mp4")} subtitles={subtitles} /> */}
        </div>);
    }
}

export default VideoExample;



// WEBPACK FOOTER //
// ./src/pages/examples/Video.tsx